import {
  AudienceComparisonColumn,
  AudienceComparisonParams,
  AudienceSettings,
  AudienceType,
  SpaceAxis,
} from "../../types/audience-compare";

import ResultTable from "../results-table/ResultTable";
import css from "./AudienceCompareResultsLoader.module.css";
import { useAudienceComparisons } from "../../queries";

type AudienceCompareResultsLoaderProps = AudienceSettings & {
  audienceType: AudienceType;
  axes: SpaceAxis[];
  className?: string;
  baselineWeighting?: string;
  audienceWeighting?: string;
  columns: AudienceComparisonColumn[];
};

/**
 * Fetches data and renders tables for the given args.
 *
 * Handles the data fetching for an entire tab.
 * The data fetching is intentionally done in this component to help reset state between tabs/dropdowns.
 * We will use a React `key` to re-mount this component each time a param is changed.
 * This ensures that our query starts fresh queuing items at index 0.
 */
const AudienceCompareResultsLoader = ({
  axes,
  audienceType,
  audience,
  baseline,
  dateFilter,
  baselineWeighting,
  audienceWeighting,
  columns,
}: AudienceCompareResultsLoaderProps) => {
  const queryParams: AudienceComparisonParams[][] = axes.map((x) =>
    x.traits.map((t) => ({
      baseline,
      audienceType,
      audience,
      dateFilter,
      attUri: t.attUri,
      scoreUri: t.scoreUri,
      baselineWeightingScheme: baselineWeighting,
      audienceWeightingScheme: audienceWeighting,
    })),
  );

  const rowQueries = useAudienceComparisons(queryParams);

  return (
    <div className={css.content}>
      {rowQueries.map((queries, i) => (
        <div key={axes[i].label} className={css.card}>
          <ResultTable
            label={axes[i].label}
            rows={queries.map((query, j) => ({
              label: axes[i].traits[j].label,
              data: query,
            }))}
            columns={columns}
          />
        </div>
      ))}
    </div>
  );
};

export default AudienceCompareResultsLoader;
